import React from 'react'
import {Grid, Typography, Link } from '@mui/material';
import colors from '../../../colors'
import Card from '@mui/material/Card';
import Lottie from "lottie-react";
import { useSelector, useDispatch } from 'react-redux';
import { setGeneralMessage} from '../../../../features/global/globalDataSlice'
import {selectTopUpData, setCurrentAction, setIsCardSuccessfullyAdded, setIsCardSuccessfullyRemoved,setIsCardOnFileTopUpSuccessfullyCompleted, setShouldFetchCards,resetTopUpSlice} from '../../../../features/userInfo/topUpSlice'
import { ReactComponent as TopUpCardOptionLogo } from '../../../../icons/TopUpCardOptionLogo.svg';
import { sendGeneralRequest } from '../../../../features/generalRequest'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import smallLoadingAnimation from '../../../../icons/lottieAnimations/smallLoading.json'
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import AddCardNew from './AddCardNew';
import { texts } from '../../../general/texts';
import MakePayment from './MakePayment'
import AddNewCardFrame from './AddNewCardFrame'
import TopUpSuccesView from './TopUpSuccesView';
import CardList from './CardList';
import OtpPrompt from './OtpPrompt';
import { selectGlobalDataState } from '../../../../features/global/globalDataSlice';
import { selectUtilityState } from '../../../../features/utilities/utilitySlice';

export const CardOnFile = () => {
  const topUpDataSliceState = useSelector(selectTopUpData)
  const globalDataSliceState = useSelector(selectGlobalDataState)
    const utilitySliceState = useSelector(selectUtilityState)
  const dispatch = useDispatch()
  const navigate = useNavigate()
//   const onBack = () => 
//   {
//     dispatch(setShouldDisplayIFrame(false))
//   }
  
//   React.useEffect(()=>{
//       if(topUpDataSliceState.shouldFetchCards)
//       {
//         dispatch(setShouldFetchCards(false))    
//         dispatch(sendGeneralRequest({request: {_request: {token: globalDataSliceState.token, cardID: null}}, baseUrlKey:'services', endpoint:'GetRegisteredCards'}))   
//       }    
//   },[topUpDataSliceState.shouldFetchCards])

React.useEffect(()=>{
    return(()=>{
        dispatch(resetTopUpSlice())
    })
},[])
React.useEffect(()=>{ 
    dispatch(sendGeneralRequest({request: {_request: {token: globalDataSliceState.token, cardID: null}}, baseUrlKey:'services', endpoint:'GetRegisteredCards'}))   
},[])

//   React.useEffect(()=>{
//         if(topUpDataSliceState.isCardSuccessfullyAdded)
//         {
//             dispatch(setGeneralMessage({type: 'success', message: texts["message-credit-card-added"]}))
//             dispatch(setIsCardSuccessfullyAdded(false))
//             dispatch(setShouldFetchCards(true))
//             //dispatch(setCurrentAction('makePayment'))
//         }
//     },[topUpDataSliceState.isCardSuccessfullyAdded])

//     React.useEffect(()=>{
//         if(topUpDataSliceState.isCardSuccessfullyRemoved)
//         {
//             dispatch(setGeneralMessage({type: 'success', message: texts["message-credit-card-deleted"]}))
//             dispatch(setIsCardSuccessfullyRemoved(false))
//             dispatch(setShouldFetchCards(true))
//         }
//     },[topUpDataSliceState.isCardSuccessfullyRemoved])

    React.useEffect(()=> {
        if(topUpDataSliceState.shouldFetchCards)
        {
            dispatch(setGeneralMessage({type: 'success', message: texts["message-notification-get-cards-successfull"]}))
            dispatch(sendGeneralRequest({request: {_request: {token: globalDataSliceState.token, cardID: null}}, baseUrlKey:'services', endpoint:'GetRegisteredCards'}))
            dispatch(setShouldFetchCards(false))
        }
        
    },[topUpDataSliceState.shouldFetchCards])

    React.useEffect(()=>{
        if(topUpDataSliceState.isCardOnFileTopUpSuccessfullyCompleted)
        {
            dispatch(setGeneralMessage({type: 'success', message: texts["message-success-trx"]}))
            dispatch(setIsCardOnFileTopUpSuccessfullyCompleted(false))
        }
    },[topUpDataSliceState.isCardOnFileTopUpSuccessfullyCompleted])

    React.useEffect(() => {
        if (utilitySliceState.isScaRequired) {
            if (topUpDataSliceState.shouldDisplayOtpPrompt && utilitySliceState.isScaCompleted) {
                dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, value: topUpDataSliceState.cardOnFilePaymentValue, cardID: topUpDataSliceState.selectedCard, transID: utilitySliceState.transactionId, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true }, baseUrlKey: 'services', endpoint: 'CreditBalanceCardsOnFile' }))
            }
        }
        else if (topUpDataSliceState.shouldDisplayOtpPrompt) {
            dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, value: topUpDataSliceState.cardOnFilePaymentValue, cardID: topUpDataSliceState.selectedCard, transID: utilitySliceState.transactionId, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true }, baseUrlKey: 'services', endpoint: 'CreditBalanceCardsOnFile' }))
        }
    }, [utilitySliceState.isScaCompleted, topUpDataSliceState.shouldDisplayOtpPrompt])


    const useStyles = makeStyles({
       
        iconButton:{
            height:'4rem',
            borderRadius:'100%',
            "&:hover":{background:colors.white}
        },
        header:{
            color:colors.darkBlue,
            fontFamily:'GerberaBold',
            fontSize:'1.5rem',
            paddingLeft:'3%',
            paddingTop:'1%',
            fontSize:'1.5rem'
        },
        button:{
            backgroundColor:colors.orange,
            color:colors.white,
            fontFamily:'GerberaBold',
            fontSize:'1rem',
            textTransform:'none',
            '&:hover':{background:colors.orange}
        },
        text:{
            color:colors.darkBlue,
            fontFamily:'GerberaLight',
            textAlign:"start"
        }
    })

  const classes = useStyles()

  return (
    <Grid container spacing={'2%'} pt={'2%'} >
        <Grid container item md={6.5} xs={12} justifyContent={{md:'right', xs:'center'}}  >
            <Card sx={{borderRadius:'20px', boxShadow:'0 0 15px 5px #E5E7EA', width:'60%', '@media (max-width: 1440px )' : {width:'70%'}, '@media (max-width: 1320px )' : {width:'90%'}}}>
                {topUpDataSliceState.shouldDisplayIFrame ? <AddNewCardFrame/>  : <MakePayment/>} 
                <Grid container justifyContent={'center'}>
                    <Grid item md={3} xs={3}>{topUpDataSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}</Grid>
                </Grid>                                                                    
            </Card>            
        </Grid>
        <Grid container item md={4.5} xs={12} justifyContent={{md:'left', xs:'center'}}  > 
            <CardList />
        </Grid>
    </Grid> 
  )
}
export default CardOnFile
